import React, { useEffect, useRef, useState } from 'react'
import QRCode from 'react-qr-code';
import * as htmlToImage from "html-to-image";
import { useNavigate, useParams } from 'react-router-dom';


import axios from "../axiosInstance";
import SidebarUserAgency from '../components/SidebarUserAgency';
import TopbarAgencyUser from '../components/TopBarAgencyUser';
import { Button, Modal } from 'react-bootstrap';
import { errorMessage } from '../hooks/UserLogs';
export default function CustomerDetailsOfAgency() {
  const [agency,setAgency] = useState({});
  const [agent, setAgent] = useState({});
  const [profile, setProfile] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [showError, setShowError] = useState(false);
  const [ListAgencies, setListAgencies] = useState([]);
  const [idAgent, setIdAgent] = useState("");
  const [percent, setPercent] = useState(0);
  const [showPercenChange, setShowPercenChange] = useState(false)
  const qrCodeRef = useRef(null);
  const inputFile = useRef(null);
  const { id } = useParams();
  const bUrl = process.env.REACT_APP_B_URL;
  const navigate = useNavigate();

  const axiosInstance = axios.create({
                        withCredentials: true,
                      })

  let header =
  {
    'Content-Type': 'application/json'
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }

  const getAgent = async () => {
    const response = await axiosInstance.get(bUrl + "/customer-wallet/find-by-id?id=" + id).catch((err) => {
      
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        seterrMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true);
      } else {
        setShowError(true);
      }

      setIsLoading(false)
    });

    if (response) {
      if (response.status == 401) {
        navigate('/agency-user-login');
      }
      
      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowError(true);
      }else {
        setAgent(response.data.body);
      }

      setIsLoading(false);
    }
  }

  const handleCloseUpdate = () => {
    setPercent(0);
    setShowPercenChange(false);
  }

  const upadatePercent = () => {
    
    let percentValue = percent / 100;
    if(percentValue<agency?.percentagePurchase){
       axios.post(bUrl + "/customer-wallet/define-percentage-purchase",
      {
        "idAgencyUser": sessionStorage.getItem('idAgencyUser'),
        "idCustomer": id,
        "percentage": percentValue

      }
      , { header: header })
      .then(function (response) {
        setShowPercenChange(false);
        
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          seterrMsg(msg);
          setShowError(true);
        }else{
          getAgent();
        }

      })
      .catch(function (err) {
        setIsLoading(false)
        setShowPercenChange(false);
        if (err?.response?.status == 401 || err?.response?.status == 403) {
          seterrMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        } else {
          setShowError(true);
        }
        //setShowError(true);
      });
    }else{
      seterrMsg("Pourcentage d'achat supérieur à celui de l'agence!!!")
      setShowError(true);
    }
   
  }
  const activeOrDeactiveCustomer = async (id, isactice) => {

  }

  const blokeOrDeblokeCustomer = async (id, isactice) => {

  }


  const handleFileChange = (e) => {
    if (e.target.files) {
      setProfile(e.target.files[0]);
      const formData = new FormData();
      formData.append('formFile', e.target.files[0], id + '.jpg');
      //formData.append('fileName',idEmp+'.jpg');
      axios.post(bUrl + '/UploadFile', formData).then((res) => {
        //setView(false);
        setTimeout(() => {
          //viewShow(idEmp)
        }, 1000)

      }).catch((err) => {
        console.log(err);
      })
    }
  };

  const handleCloseError = () => {
    setShowError(false);
  }

 const getAgency = async () => {

   let idAg=sessionStorage.getItem("idAgency");
    const response = await axios.get(bUrl + "/agencies/Agency-by-Id?id=" + idAg).catch((err) => {
      console.log(err);
      setIsLoading(false)

    });
    if (response) {

      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowError(true);
      } else {
        
        setAgency(response.data.body);
      }

      setIsLoading(false);

      if (response.status == 401) {
        navigate('/agency-user-login');
      }
    }
  }
  const masterToAgency = async (idAgency, idCustomer) => {
    setIdAgent(idAgency);
    let conf = window.confirm("Etes vous sure de vouloir changé l'agence ?");

    if (conf) {
      const response = await axios.post(bUrl + "/customer-wallet/customer-wallet-to-agency", {
        "idCustomerWallet": idCustomer,
        "idAgency": idAgency,
        "idStaff": sessionStorage.getItem("idUser")
      }).catch((err) => {
        console.error(err);
        if (err?.response?.status == 401 || err?.response?.status == 403) {
          seterrMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        } else {
          let msg = errMsg = + ' ' + err?.response?.status;
          seterrMsg(msg);
          setShowError(true);
        }

        setIsLoading(false)

      });
      if (response) {
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          seterrMsg(msg);
          setShowError(true);
        }else{
          getAgent()
        }

        if (response.status == 401) {
          navigate('/agency-user-login');
        }
        
        setIsLoading(false);
      }
    }
  }

  const downloadQRCode = () => {
    htmlToImage.toPng(qrCodeRef.current).then(function (dataUrl) {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "qr-code.png";
      link.click();
    })
      .catch(function (error) {
        console.error("Error generating QR code:", error);
      });
  };

  useEffect(() => {
    if (sessionStorage.getItem("idAgency") === '' || sessionStorage.getItem("idAgency") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/agency-user-login');
    }
    getAgent();
    getAgency();

  }, []);
  return (
    <div>
      <SidebarUserAgency />
      <section className="home ">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
              <div><p className='fw-bold'>{agent !== null ? agent.profile == 'CUSTOMER' ? 'Clients' : 'Agent' : ""} &gt; Détails</p></div>
              <div><TopbarAgencyUser /></div>
            </div>
            {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
              <div className="table-content mt-3 p-3">
                <div className='row d-flex justify-content-center'>
                  {/* <div className='col-md-3'><input type="file" multiple ref={inputFile} hidden onChange={(e)=>handleFileChange(e)}/>
            <img src={agent.name} alt='img' className='w-100 im-upload' /> 
            </div> */}
                  <div className='col-md-3 bg-primary'>
                  </div>
                  {/* <button className='btn' onClick={} >Changer</button> */}

                  {agent?
                  <div className='col-md-6'>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Name:</div>
                      <div className='col-8 fw-bold'>{agent.firstName + " " + agent.middleName + " " + agent.lastName}</div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Numéro Téléphone:</div>
                      <div className='col-8 fw-bold'>{agent.phone}
                      </div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Code:</div>
                      <div className='col-8 fw-bold'>{agent.code}
                      </div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Date Création:</div>
                      <div className='col-8 fw-bold'>{formatDate(agent.createdDate)}
                      </div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Pourcentage d'achat:</div>
                      <div className='col-8 fw-bold'>
                        {agent.percentagePurchase + " % "}
                        <a className='clickable btn-link' onClick={() => setShowPercenChange(true)}>Changer</a>
                      </div>
                    </div>

                    {agent?.accounting?
                      <>
                        <div className='row mb-2 row-details p-2'>
                          <div className='col-4'>Solde:</div>
                          <div className='col-8 fw-bold'>{agent.accounting.balance} {agent.accounting.currency}</div>
                        </div>
                      </>
                      : ""}


                    {agent?.staff?
                      <>
                        <div className='row mb-2 row-details p-2'>
                          <div className='col-4'>Modifié Par:</div>
                          <div className='col-8 fw-bold'>{agent.staff.firstName + ' ' + agent.staff.middleName + ' ' + agent.staff.lastName + " | " + agent.staff.login}</div>
                        </div>
                      </>
                      : ""}

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Bloque:</div>
                      <div className='col-8 fw-bold'>
                        <label className="switch">
                          <input type="checkbox" className="i-btn" checked={agent.isBlocked ? 'checked' : ''} onChange={(e) => blokeOrDeblokeCustomer(agent.idCustomerWallet, e.target.checked)} />
                          <span className="slider-btn round"></span>
                        </label>
                      </div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Active:</div>
                      <div className='col-8 fw-bold'>
                        <label className="switch">
                          <input type="checkbox" className="i-btn" checked={agent.isActive ? 'checked' : ''} onChange={(e) => activeOrDeactiveCustomer(agent.idCustomerWallet, e.target.checked)} />
                          <span className="slider-btn round"></span>
                        </label>
                      </div>
                    </div>

                  </div>
                  :<></>}
                  <div className='qr-containe col-md-3' ref={qrCodeRef} >

                  </div>
                  <Modal show={showPercenChange} onHide={handleCloseUpdate} className="sm">
                    <Modal.Header closeButton>
                      <Modal.Title>Modifier le Pourcentage d'achat</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className='row'>
                        <div className='col-md-6'>
                          <input type='number' min={0} max={(agency?(agency.percentagePurchase*100):0)- 0.5} value={percent}
                            onChange={(e) => setPercent(e.target.value)} className="form-control form-control-sm" />

                        </div>
                        <div className='col-md-6' style={{ fontWeight: 'bold', fontSize: '1.5em' }}>%</div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={upadatePercent}>
                        Modifier
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <Modal show={showError} onHide={handleCloseError} className="">
                    <Modal.Header closeButton className="bg-danger">
                      <Modal.Title>ERROR</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleCloseError}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    </div>
  )
}

